export default __webpack_public_path__ + "static/photo22usluge-10f8338cb6482d1083030bd103ea547c.png";